import { render } from "./TheMobilityDocumentation.vue?vue&type=template&id=95e92400"
import script from "./TheMobilityDocumentation.vue?vue&type=script&lang=js"
export * from "./TheMobilityDocumentation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__